import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './containers/App';
import configureStore from "./redux/configureStore";
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import config from './config/config';
import { loadScript } from './utils/loadScript';

const store = configureStore();

function renderApp() {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>,
    document.getElementById("root")
  );
}

// Osano before app shell so consent can gate Adobe and other tags in App.js
loadScript(config.OSANO_SCRIPT_URL, { id: 'osano-cmp', async: false })
  .catch(() => {
    // Non-blocking: app still loads if CMP is unreachable
  })
  .finally(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
